__turbopack_context__.v({
  "blok-big-title": "AlgoliaSearchInput-module__dFDHiG__blok-big-title",
  "blok-subtitle": "AlgoliaSearchInput-module__dFDHiG__blok-subtitle",
  "blok-title": "AlgoliaSearchInput-module__dFDHiG__blok-title",
  "searchIcon": "AlgoliaSearchInput-module__dFDHiG__searchIcon",
  "searchInput": "AlgoliaSearchInput-module__dFDHiG__searchInput",
});
